import PropTypes from 'prop-types'

import Shimmer from 'Components/shimmer'
import MaleDailyArticleCardOneShimmer from './article_card/style_one/shimmer'
import MaleDailyArticleCardFourShimmer from './article_card/style_four/shimmer'
import MaleDailyArticleCardTwoShimmer from './article_card/style_two/shimmer'
import MaleDailyArticleCardThreeShimmer from './article_card/style_three/shimmer'
import MaleDailyArticleCardFiveShimmer from './article_card/style_five/shimmer'

const MaleDailyArticlesShimmer = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div
        className={`maledaily-articles-shimmer maledaily-articles-shimmer--${device}`}
      >
        <div
          className={`maledaily-articles-shimmer__title maledaily-articles-shimmer__title--${device}`}
        >
          <Shimmer width={isMobile ? '280px' : '600px'} height="12px" />
        </div>
        <div
          className={`maledaily-articles-shimmer__content maledaily-articles-shimmer__content--${device}`}
        >
          <div
            className={`maledaily-articles-shimmer__latest maledaily-articles-shimmer__latest--${device}`}
          >
            <div className="maledaily-articles-shimmer__main">
              <MaleDailyArticleCardOneShimmer isMobile={isMobile} />

              {!isMobile && (
                <MaleDailyArticleCardFourShimmer isMobile={isMobile} />
              )}
            </div>
            <div
              className={`maledaily-articles-shimmer__top maledaily-articles-shimmer__top--${device}`}
            >
              <div
                className={`maledaily-articles-shimmer__secondary maledaily-articles-shimmer__secondary--${device}`}
              >
                <MaleDailyArticleCardTwoShimmer isMobile={isMobile} />
                <MaleDailyArticleCardTwoShimmer isMobile={isMobile} />
              </div>
              <div
                className={`maledaily-articles-shimmer__tertiary maledaily-articles-shimmer__tertiary--${device}`}
              >
                <MaleDailyArticleCardThreeShimmer isMobile={isMobile} />
                <MaleDailyArticleCardThreeShimmer isMobile={isMobile} />
              </div>

              {isMobile && (
                <MaleDailyArticleCardFourShimmer isMobile={isMobile} />
              )}
            </div>
          </div>
          <div
            className={`maledaily-articles-shimmer__others maledaily-articles-shimmer__others--${device}`}
          >
            {[...Array(6).keys()].map((key) => (
              <MaleDailyArticleCardFiveShimmer key={key} />
            ))}
          </div>
          <div className="maledaily-articles-shimmer__action-wrapper">
            <Shimmer width={isMobile ? '100%' : '145px'} height="48px" />
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .maledaily-articles-shimmer {
            width: 100%;
            max-width: 1000px;
            margin: auto;
          }

          .maledaily-articles-shimmer--mobile {
            max-width: 360px;
          }

          .maledaily-articles-shimmer__title {
            display: flex;
            justify-content: center;
            margin-bottom: var(--space-40);
          }

          .maledaily-articles-shimmer__title--mobile {
            margin-bottom: var(--space-20);
          }

          .maledaily-articles-shimmer__content--mobile {
            padding: 0px var(--space-16);
          }

          .maledaily-articles-shimmer__latest {
            display: grid;
            grid-template-columns: 400px 1fr;
            gap: 80px;
            margin-bottom: var(--space-80);
          }

          .maledaily-articles-shimmer__latest--mobile {
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: var(--space-20);
          }

          .maledaily-articles-shimmer__main {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .maledaily-articles-shimmer__top {
            display: flex;
            flex-direction: column;
            gap: 40px;
          }

          .maledaily-articles-shimmer__top--mobile {
            gap: 20px;
          }

          .maledaily-articles-shimmer__secondary {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }

          .maledaily-articles-shimmer__secondary--mobile {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
          }

          .maledaily-articles-shimmer__tertiary {
            display: flex;
            flex-direction: column;
            gap: 40px;
          }

          .maledaily-articles-shimmer__tertiary--mobile {
            gap: 20px;
          }

          .maledaily-articles-shimmer__others {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 80px 20px;
            margin-bottom: var(--space-40);
          }

          .maledaily-articles-shimmer__others--mobile {
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: var(--space-20);
          }

          .maledaily-articles-shimmer__action-wrapper {
            display: flex;
            justify-content: center;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticlesShimmer.propTypes = {
  isMobile: PropTypes.bool,
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ),
}

export default MaleDailyArticlesShimmer
